{
  "tabs": {
    "chat": "Чат",
    "reminders": "Нагадування",
    "calendar": "Календар",
    "settings": "Налаштування"
  },
  "common": {
    "cancel": "Скасувати",
    "save": "Зберегти",
    "confirm": "Підтвердити",
    "delete": "Видалити",
    "back": "Назад",
    "close": "Закрити",
    "edit": "Редагувати",
    "search": "Пошук",
    "all": "Всі",
    "loading": "Завантаження...",
    "error": "Щось пішло не так",
    "notFound": "Не знайдено",
    "tryAgain": "Спробуйте ще раз",
    "retry": "Повторити",
    "undo": "Скасувати",
    "pullToRefresh": "Потягніть для оновлення",
    "justNow": "щойно"
  },
  "auth": {
    "welcome": "Ласкаво просимо до FishMemory",
    "tagline": "Ваш помічник нагадувань WhatsApp, тепер у вашій кишені.",
    "subtitle": "Ваш помічник нагадувань WhatsApp, тепер у вашій кишені.",
    "phoneLabel": "Ваш номер WhatsApp",
    "phoneHint": "Ми надішлемо код підтвердження через WhatsApp",
    "invalidPhone": "Введіть дійсний номер телефону",
    "continue": "Продовжити",
    "enterPhone": "Введіть ваш номер WhatsApp",
    "phonePlaceholder": "Номер телефону",
    "sendCode": "Надіслати код",
    "verifyTitle": "Підтвердіть номер",
    "otpSentTo": "6-значний код надіслано на {{phone}} через WhatsApp",
    "enterFullCode": "Введіть усі 6 цифр",
    "invalidOtp": "Неправильний код. Спробуйте ще раз.",
    "otpFailed": "Не вдалося надіслати код. Спробуйте ще раз.",
    "otpResent": "Код надіслано повторно",
    "resendIn": "Повторити через {{seconds}}с",
    "resendCode": "Повторити код",
    "enterOtp": "Введіть код, надісланий у WhatsApp",
    "verify": "Підтвердити",
    "resend": "Повторити код",
    "wrongNumber": "Неправильний номер?",
    "backToPhone": "Назад до номера",
    "editPhone": "Редагувати номер",
    "error": "Помилка",
    "setupTitle": "Налаштуємо все",
    "setupSubtitle": "Ці налаштування можна змінити пізніше в Налаштуваннях",
    "namePlaceholder": "Ваше ім’я",
    "letsGo": "Завершити налаштування",
    "skipForNow": "Пропустити"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Введіть повідомлення...",
    "inputPlaceholder": "Введіть повідомлення...",
    "typing": "FishMemory набирає...",
    "online": "В мережі",
    "connecting": "Підключення...",
    "reconnecting": "Повторне підключення...",
    "offline": "Офлайн",
    "empty": "Почніть розмову",
    "emptyHint": "Створюйте нагадування, перевіряйте розклад або запитуйте допомогу.",
    "emptyAction": "Надіслати приклад нагадування",
    "actions": "Дії чату",
    "keep": "Зберегти повідомлення",
    "clearTitle": "Очистити чат",
    "clearConfirm": "Видалити всі повідомлення з цього пристрою? Це не можна скасувати.",
    "clear": "Очистити чат",
    "optionSelected": "Вибрано: {{label}}",
    "sendingSelection": "Надсилання...",
    "connectionLost": "Повторне підключення..."
  },
  "reminders": {
    "title": "Мої нагадування",
    "active": "Активні",
    "today": "Сьогодні",
    "thisWeek": "Цього тижня",
    "history": "Історія",
    "items": "елементів",
    "emptyTitle": "Немає нагадувань",
    "emptySubtitle": "Створіть нагадування в чаті, і воно з’явиться тут.",
    "emptyAction": "Відкрити чат",
    "filterActive": "Активні",
    "filterToday": "Сьогодні",
    "filterWeek": "Цього тижня",
    "filterHistory": "Історія",
    "emptyState": "Немає нагадувань. Почніть спілкування!",
    "swipeDone": "Виконано",
    "swipeSnooze": "Відкласти",
    "swipeDelete": "Видалити",
    "search": "Пошук нагадувань...",
    "upcoming": "Найближчі",
    "completed": "Виконані",
    "overdue": "Прострочені",
    "tomorrow": "Завтра",
    "synced": "Синхронізовано {{value}}",
    "swipeHint": "Проведіть нагадування для додаткових дій",
    "noResults": "Немає нагадувань за вашим запитом",
    "noResultsHint": "Спробуйте інший запит або очистіть пошук",
    "deleteAllFailed": "Не вдалося видалити всі нагадування"
  },
  "calendar": {
    "title": "Календар",
    "today": "Сьогодні",
    "tomorrow": "Завтра",
    "completed": "виконано",
    "noEvents": "Немає подій",
    "noEventsSubtitle": "Виберіть дату, щоб побачити нагадування та події календаря.",
    "googleEvent": "Google Calendar",
    "legendActive": "Активні",
    "legendRecurring": "Повторювані",
    "legendDone": "Виконані",
    "legendGoogle": "Google",
    "previousMonth": "Попередній місяць",
    "nextMonth": "Наступний місяць",
    "previousYear": "Мин. рік",
    "nextYear": "Наст. рік",
    "goToToday": "Перейти до сьогодні",
    "all": "Всі",
    "active": "Активні",
    "done": "Виконані",
    "paused": "Призупинені"
  },
  "settings": {
    "title": "Налаштування",
    "profile": "Профіль",
    "name": "Ім’я для показу",
    "enterName": "Введіть ім’я",
    "language": "Мова",
    "uiLanguage": "Мова додатку",
    "uiLanguageHelp": "Змінює мову інтерфейсу, підписи календаря та напрямок макета лише на цьому пристрої.",
    "serverLanguage": "Мова чату",
    "serverLanguageHelp": "Змінює мову відповідей сервера та повідомлень нагадувань для вашого акаунта.",
    "timezone": "Часовий пояс",
    "currentTimezone": "Поточний часовий пояс",
    "timezoneHelp": "Усі часи нагадувань показуються з урахуванням цього часового поясу.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Зберегти часовий пояс",
    "timezoneSaved": "Часовий пояс оновлено",
    "detect": "Визначити",
    "detectFailed": "Не вдалося визначити часовий пояс",
    "autoDetect": "Автовизначення за GPS",
    "notifications": "Сповіщення",
    "notificationsHelp": "Повторні нагадування контролюють повторні оповіщення після доставки нагадування. Дозволи на сповіщення керуються в налаштуваннях телефону.",
    "pushEnabled": "Push-сповіщення",
    "autoDoneOnFire": "Автоматично позначати виконаним при спрацьовуванні",
    "autoDoneOnFireDesc": "Якщо вимкнено, нагадування залишаються активними, доки ви їх не позначите як виконані.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Підключено",
    "googleDisconnected": "Не підключено",
    "googleConnectedHelp": "Нові нагадування можна автоматично синхронізувати з календарем.",
    "googleDisconnectedHelp": "Підключіть Google Calendar, щоб узгодити нагадування та події.",
    "googleConnectFailed": "Не вдалося підключити Google Calendar",
    "connected": "Підключено",
    "disconnected": "Не підключено",
    "connect": "Підключити",
    "disconnect": "Відключити",
    "autoSync": "Автосинхронізація нових нагадувань",
    "autosync": "Автосинхронізація нових нагадувань",
    "subscription": "Підписка",
    "trialUsed": "Пробний період: використано {{used}}/{{total}}",
    "trialStatus": "Доступний пробний період",
    "activeStatus": "Активна підписка",
    "expiredStatus": "Підписка закінчилась",
    "unsubscribedStatus": "Не підписано",
    "about": "Про програму",
    "version": "Версія",
    "logout": "Вийти",
    "logoutTitle": "Вийти",
    "logoutConfirm": "Ви впевнені, що хочете вийти?",
    "noName": "Ім’я не встановлено",
    "serverConnection": "Підключення до сервера",
    "serverUrl": "URL сервера",
    "serverEdit": "Редагувати",
    "saveReconnect": "Зберегти та підключитись",
    "resetDefault": "Скинути за замовчуванням",
    "invalidServerUrlTitle": "Недійсний URL сервера",
    "invalidServerUrlMessage": "Введіть дійсний URL сервера http або https, наприклад https://example.com",
    "uiLanguageChangeFailed": "Не вдалося змінити мову додатку. Спробуйте ще раз.",
    "serverLanguageChangeFailed": "Не вдалося змінити мову чату. Спробуйте ще раз.",
    "timezoneChangeFailed": "Не вдалося змінити часовий пояс. Спробуйте ще раз.",
    "autoSyncChangeFailed": "Не вдалося оновити автосинхронізацію. Спробуйте ще раз.",
    "nameChangeFailed": "Не вдалося оновити ім’я для показу. Спробуйте ще раз.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Деталі нагадування",
    "editTime": "Редагувати час",
    "rename": "Перейменувати",
    "snooze": "Відкласти",
    "snooze15": "Відкласти на 15 хвилин",
    "pause": "Призупинити",
    "pauseReminder": "Призупинити нагадування",
    "resume": "Продовжити",
    "resumeReminder": "Продовжити нагадування",
    "skip": "Пропустити наступне",
    "skipOccurrence": "Пропустити це повторення",
    "syncGoogle": "Синхронізувати з Google",
    "delete": "Видалити",
    "deleteTitle": "Видалити нагадування",
    "deleteConfirm": "Це нагадування буде видалено назавжди.",
    "deleteRecurringTitle": "Видалити повторюване нагадування",
    "deleteRecurringMessage": "Ви хочете пропустити це повторення чи видалити всю серію?",
    "deleteThisOccurrence": "Пропустити це повторення",
    "deleteEntireSeries": "Видалити всю серію",
    "done": "Виконано",
    "markDone": "Позначити як виконане",
    "undo": "Відновити",
    "undoPrompt": "Потрібно знову активувати? Відновіть зараз.",
    "recurring": "Повторюване",
    "nextRun": "Наступне спрацьовування",
    "oneTime": "Одноразове",
    "pending": "Очікує",
    "sent": "Надіслано",
    "paused": "Призупинено",
    "active": "Активне",
    "snoozed": "Відкладене",
    "localTime": "Показано у вашому місцевому часі",
    "recurrence": "Повторення",
    "created": "Створено",
    "tags": "Теги",
    "fireCount": "Кількість спрацьовувань",
    "actions": "Дії",
    "none": "Немає",
    "snoozeFailed": "Не вдалося відкласти нагадування",
    "pauseFailed": "Не вдалося призупинити нагадування",
    "resumeFailed": "Не вдалося продовжити нагадування",
    "skipFailed": "Не вдалося пропустити нагадування",
    "doneFailed": "Не вдалося позначити нагадування як виконане",
    "undoFailed": "Не вдалося відновити статус нагадування",
    "deleteFailed": "Не вдалося видалити нагадування",
    "rescheduleTitle": "Перепланувати?",
    "rescheduleMsg": "Це нагадування прострочене. Бажаєте перепланувати?",
    "reschedule15": "Через 15 хвилин",
    "reschedule60": "Через 1 годину",
    "keepOverdue": "Залишити як є"
  },
  "onboarding": {
    "slide1Title": "Ласкаво просимо до FishMemory",
    "slide1Sub": "Ваш особистий помічник нагадувань — на базі WhatsApp і створений для вашої кишені.",
    "slide2Title": "Просто спілкуйтесь природно",
    "slide2Sub": "Вводьте нагадування так, як думаєте: «Нагадай зателефонувати мамі завтра о 15:00» — ми подбаємо про решту.",
    "slide3Title": "Ніколи нічого не пропустіть",
    "slide3Sub": "Отримуйте своєчасні сповіщення, організовуйте з тегами та контролюйте все важливе.",
    "getStarted": "Почати",
    "next": "Далі",
    "firstReminderTitle": "Створіть перше нагадування!",
    "firstReminderHint": "Спробуйте ввести щось на кшталт:",
    "firstReminderExample": "Нагадай випити води завтра о 9:00",
    "gotIt": "Зрозуміло!",
    "notifRationaleTitle": "Будьте вчасно",
    "notifRationaleBody": "FishMemory потребує сповіщень, щоб нагадувати вчасно. Ви отримуватимете сповіщення лише про створені вами нагадування.",
    "notifRationaleAllow": "Увімкнути сповіщення",
    "notifRationaleLater": "Пізніше",
    "swipeHint": "Проведіть вправо для швидких дій →",
    "calendarDragHint": "Тягніть для розгортання ↕"
  }
}
